import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  fetchScanHistory,
  fetchScanHistoryStart,
  fetchScanHistorySuccess,
  fetchScanHistoryFailure,
  fetchScanHistoryById,
  fetchScanHistoryByIdStart,
  fetchScanHistoryByIdSuccess,
  fetchScanHistoryByIdFailure,
} from "../slices/scanHistorySlice";
import { makeRequest } from "../../utils/api";
import { ScanHistoryResponse } from "../../types/pages/prodseals";
import { extractErrorMessage } from "../../utils/helpers";

function* fetchScanHistorySaga(
  action: PayloadAction<{
    page: number;
    rowsPerPage: number;
    sortBy?: string;
    sortOrder?: number;
    possible_counterfeit?: boolean;
  }>,
): Generator<any, void, any> {
  try {
    yield put(fetchScanHistoryStart());
    const skip = action.payload.page * action.payload.rowsPerPage;
    const limit = action.payload.rowsPerPage;
    const sortBy = action.payload.sortBy || "created_at";
    const sortOrder =
      action.payload.sortOrder !== undefined ? action.payload.sortOrder : -1;

    const counterfeitFilter =
      action.payload.possible_counterfeit !== undefined
        ? `&possible_counterfeit=${action.payload.possible_counterfeit}`
        : "";
    const endpoint = `/prodseals/scans/history?skip=${skip}&limit=${limit}
    &sort_by=${sortBy}&sort_order=${sortOrder}${counterfeitFilter}`;
    const response: ScanHistoryResponse = yield call(
      makeRequest,
      "get",
      endpoint,
    );

    yield put(fetchScanHistorySuccess(response));
  } catch (error: any) {
    yield put(fetchScanHistoryFailure(extractErrorMessage(error)));
  }
}

function* fetchScanHistoryByIdSaga(
  action: PayloadAction<{ _id: string }>,
): Generator<any, void, any> {
  try {
    yield put(fetchScanHistoryByIdStart());

    const endpoint = `/prodseals/scans/${action.payload._id}`;
    const response: any = yield call(makeRequest, "get", endpoint);
    yield put(fetchScanHistoryByIdSuccess(response));
  } catch (error: any) {
    yield put(fetchScanHistoryByIdFailure(extractErrorMessage(error)));
  }
}

export default function* scanHistorySaga(): Generator<any, void, any> {
  yield takeLatest(fetchScanHistory.type, fetchScanHistorySaga);
  yield takeLatest(fetchScanHistoryById.type, fetchScanHistoryByIdSaga);
}
